export default "__VITE_ASSET__DJoHlyrc__"